module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "course"
    }
  }, [_c('h1', {
    staticClass: "title twotitle"
  }, [_vm._v("課程")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "timetable"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    attrs: {
      "rowspan": "5"
    },
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 1)
      }
    }
  }, [_c('p', [_vm._v("神秘的修業")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("\n            HTTP、RESTful 觀念與實作\n          ")])]), _vm._v(" "), _c('td', {
    staticClass: "activity cursor",
    attrs: {
      "rowspan": "5"
    },
    on: {
      "click": function($event) {
        _vm.showTheWorldCafe = true
      }
    }
  }, [_c('p', [_vm._v("傳承")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("\n            視界咖啡館\n          ")])]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 7)
      }
    }
  }, [_c('p', [_vm._v("遙遠的記憶")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("SITCON 2017 論壇系統")])])]), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 8)
      }
    }
  }, [_c('p', [_vm._v("最後的魔法")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("AI")])])]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('tr', [_vm._m(13), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 0)
      }
    }
  }, [_c('p', [_vm._v("魔法師之路")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("Python 3")])]), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 2)
      }
    }
  }, [_c('p', [_vm._v("魔法師之路 II")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("Python 3 × HTTP")])]), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 4)
      }
    }
  }, [_c('p', [_vm._v("尼斯的手冊")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("Telegram Chatbot")])]), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('tr', [_vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 3)
      }
    }
  }, [_c('p', [_vm._v("源力之美")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("開源社群精神")])]), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 5)
      }
    }
  }, [_c('p', [_vm._v("突如其來的訪客")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("網頁（前端）是什麼")])])]), _vm._v(" "), _c('tr', [_vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('td', {
    staticClass: "activity cursor",
    attrs: {
      "rowspan": "4"
    },
    on: {
      "click": function($event) {
        _vm.showCommunity = true
      }
    }
  }, [_c('p', [_vm._v("魔法師的宴會")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("晚餐＆社群闖關")])]), _vm._v(" "), _vm._m(20)]), _vm._v(" "), _c('tr', [_vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 6)
      }
    }
  }, [_c('p', [_vm._v("與黑魔法師的約會")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("資訊安全")])])]), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25)])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle bluecar"
  }, [_vm._v("廣度課程與短講")]), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("社群闖關")]), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('h2', {
    staticClass: "subtitle bluecar"
  }, [_vm._v("視界咖啡館")]), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("Hackathon")]), _vm._v(" "), _vm._m(29), _vm._v(" "), (_vm.showFancyBox) ? _c('Fancybox', {
    on: {
      "close": function($event) {
        _vm.showFancyBox = false
      }
    }
  }, [_c('div', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.showFancyBox = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.boxContent.title))]), _vm._v(" "), _vm._l((_vm.boxContent.introduction), function(paragraph, index) {
    return _c('p', {
      key: index,
      staticClass: "content"
    }, [_vm._v(_vm._s(paragraph))])
  }), _vm._v(" "), _vm._l((_vm.boxContent.speakers), function(speaker, index) {
    return _c('div', {
      key: index
    }, [_c('h2', {
      staticClass: "subtTitle"
    }, [_vm._v(_vm._s(speaker.name))]), _vm._v(" "), _c('p', {
      staticClass: "content"
    }, [_vm._v(_vm._s(speaker.introduction))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showTheWorldCafe) ? _c('Fancybox', {
    on: {
      "close": function($event) {
        _vm.showTheWorldCafe = false
      }
    }
  }, [_c('div', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.showTheWorldCafe = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.theWorldCafe.title))]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.theWorldCafe.introduction))]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("邀請講者")]), _vm._v(" "), _vm._l((_vm.theWorldCafe.speakers), function(speaker, index) {
    return _c('div', {
      key: index
    }, [_c('h2', {
      staticClass: "subtTitle"
    }, [_vm._v(_vm._s(speaker.name))]), _vm._v(" "), _c('p', {
      staticClass: "content"
    }, [_vm._v(_vm._s(speaker.introduction))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showCommunity) ? _c('Fancybox', {
    on: {
      "close": function($event) {
        _vm.showCommunity = false
      }
    }
  }, [_c('div', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.showCommunity = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("社群闖關")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("社群闖關邀請到許多資訊相關社群前來擺攤，藉由互動遊戲、影片欣賞、專人介紹...等方式，讓學員認識所謂「社群」，並對開源活動有初步了解。 ")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("邀請社群")]), _vm._v(" "), _c('ul', {
    staticClass: "community"
  }, _vm._l((_vm.communities), function(community, index) {
    return _c('li', {
      key: index
    }, [_c('h2', {
      staticClass: "subTitle"
    }, [_vm._v(_vm._s(community.name))]), _vm._v(" "), _c('div', [(community.img.length > 0) ? _c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": './static/communities/' + community.img,
        "alt": community.name
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((community.introduction), function(paragraph, index) {
      return _c('p', {
        key: index,
        staticClass: "content"
      }, [_vm._v(_vm._s(paragraph))])
    })], 2)])
  }))]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Day 1")]), _vm._v(" "), _c('td', [_vm._v("Day 2")]), _vm._v(" "), _c('td', [_vm._v("Day 3")]), _vm._v(" "), _c('td', [_vm._v("Day 4")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("07:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("07:30")])]), _vm._v(" "), _c('td', {
    staticClass: "common",
    attrs: {
      "rowspan": "3"
    }
  }, [_c('p', [_vm._v("傳送門已開啟")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("移動")])]), _vm._v(" "), _c('td', {
    staticClass: "common"
  }, [_c('p', [_vm._v("迎接太陽之光")])]), _vm._v(" "), _c('td', {
    staticClass: "common"
  }, [_c('p', [_vm._v("自我升級完成")])]), _vm._v(" "), _c('td', {
    staticClass: "common",
    attrs: {
      "rowspan": "3"
    }
  }, [_c('p', [_vm._v("養精蓄銳")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("07:30\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("09:00")])]), _vm._v(" "), _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', [_vm._v("陌生人的禮物")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("Bot Game")])]), _vm._v(" "), _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', [_vm._v("奇妙際遇")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("09:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("09:30")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_vm._v("09:30\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("10:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "activity"
  }, [_c('p', [_vm._v("學院的號召")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("集合 ＆ 報到")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "3"
    }
  }, [_c('p', [_vm._v("榮耀的盡頭")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("\n            黑客松\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("10:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("10:30")])]), _vm._v(" "), _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', [_vm._v("迎接新世界")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("開幕")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("10:30\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("11:00")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_vm._v("11:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("11:30")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', [_vm._v("新的邂逅")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("破冰活動")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_vm._v("11:30\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("12:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("12:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("13:30")])]), _vm._v(" "), _c('td', {
    staticClass: "common",
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticClass: "sub"
  }, [_vm._v("午餐")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_vm._v("13:30\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("15:30")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "activity"
  }, [_c('p', [_vm._v("黃金的光輝")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("黑客松發表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("15:30\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("16:30")])]), _vm._v(" "), _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', [_vm._v("一切的真相")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("閉幕")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_vm._v("16:30\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("17:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "common"
  }, [_c('p', [_vm._v("尋找自我")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_vm._v("17:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("18:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "common"
  }, [_c('p', [_vm._v("與市長的會面")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("晚餐")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "common",
    attrs: {
      "rowspan": "5"
    }
  }, [_c('p', [_vm._v("無悔的選擇")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("返家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_vm._v("18:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("19:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "3"
    }
  }, [_c('p', [_vm._v("無法逃離的背叛")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("19:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("20:00")])]), _vm._v(" "), _c('td', {
    staticClass: "common"
  }, [_c('p', [_vm._v("謀略之夜")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("晚餐")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("20:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("21:00")])]), _vm._v(" "), _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', [_vm._v("突擊")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("黑客松")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("21:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("22:00")])]), _vm._v(" "), _c('td', {
    staticClass: "common"
  }, [_c('p', [_vm._v("絕望中的微微亮光")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("宵夜")])]), _vm._v(" "), _c('td', {
    staticClass: "activity"
  }, [_c('p', [_vm._v("謊言與真相")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("神秘活動＆宵夜")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("今年夏令營有別於往年的單一教學方式，而是在不影響一般課程的情況，安排一些廣度課程，讓學員在學習基礎課程之餘，也能學到資訊領域的其他層面，增加自身資訊技能的廣度。 除基礎課程與廣度課程外，我們也邀請到許多在資訊領域打滾多年的人士分享自身經驗，期許迷茫中的學員，可以點燃未來的一盞明燈，在資訊道路上有前進的動力及方向。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("社群闖關邀請到許多資訊相關社群前來擺攤，藉由互動遊戲、影片欣賞、專人介紹...等方式，讓學員認識所謂「社群」，並對開源活動有初步了解。點選課表可檢視詳細的社群資訊。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("視界咖啡館參考自世界咖啡館（The World Café），在本次夏令營中，我們邀請到各領域及社群前輩，將傳統座談會形式改以小組討論的樣貌呈現，並與學員分享工作經驗、學習過程、面對困難的解決方式或希望給予 SITCON 夏令營學員的建議，提出值得學員思考、了解的觀點。期望透過縮短講師及學員間的距離，鼓勵學員踴躍提問、參與，進而產生良好的雙向交流。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("黑客松（Hackathon）是「黑客」（Hack；原指早期為電腦系統找尋不完美的地方，或是探索不同的解法，來改善電腦系統）跟「馬拉松」（Marathon）的組合字，顧名思義，也就像是程式設計、工程界的馬拉松。由有興趣的一群人在有限的時間內，發揮自己的專長做出一個有特色的專案。")]), _vm._v(" "), _c('p', [_vm._v("今年， SITCON 夏令營將為學員打造一場專屬的小型黑客松，取代傳統的晚會、唱歌跳舞等活動，以小隊為單位，在吃吃喝喝的同時，一起發揮創意、運用課程中所學，做出與眾不同的作品呈現！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1961dfcd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Course.vue
// module id = 81
// module chunks = 0